"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _setSession = _interopRequireDefault(require("../auth/setSession"));

var _getSession = _interopRequireDefault(require("../auth/getSession"));

var _handleJWTRefresh = _interopRequireDefault(require("./handleJWTRefresh"));

function _default(_ref) {
  var networkError = _ref.networkError,
      operation = _ref.operation,
      forward = _ref.forward;

  if (networkError.statusCode === 401 && networkError.result.error === 'AuthError') {
    var message = networkError.result.message;

    if (message.toLowerCase().includes('jwt')) {
      return (0, _handleJWTRefresh["default"])({
        networkError: networkError,
        operation: operation,
        forward: forward
      });
    }

    if (['sessionNotFound', 'invalidSignature'].includes(message)) {
      var session = (0, _getSession["default"])();
      console.log('Resetting session: ' + JSON.stringify(networkError.result, null, 2));

      if (session) {
        (0, _setSession["default"])(null, false);
      }
    } else {
      console.warn('Received too many nonce is invalid');
    }
  } else {
    console.warn('Network error:', networkError);
  }
}